import BFFAPI from './utils/BFFAPI';

class GatewaysAPI extends BFFAPI {
  getGateways = () => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}`);
    return this.fetch(req);
  };

  removeGateway = (id: string) => {
    const req = this.fetchHelper.createDeleteRequest(`${this.endpoint}/${id}`);
    return this.fetch(req);
  };
}

export default new GatewaysAPI('/fleet/secure/gateway');
